module.exports = __webpack_public_path__ + "static/media/siri24.76b1735d.jpg";